export interface SavedLatency {
  detected: number | null;
  adjusted: number;
}
